<script lang="ts">
  import Spinner from './spinner.svelte'
  //

  import { link_button_recipe } from './link-button.svelte.recipe'
  import type { LinkButtonProps } from './link-button.types'
  import LinkLocale from './link-locale.svelte'

  //
  const {
    children,
    variant,
    colorPalette,
    size,
    class: classNative,
    ...props
  }: LinkButtonProps = $props()

  const recipeProps = { variant, colorPalette, size }

  const className = $derived(link_button_recipe({ ...recipeProps, className: classNative }))
</script>

<LinkLocale href={props.href} class={className} {...props}>
  {#if !props.loading && !props.loadingText}
    {@render children()}
  {:else if props.loading && props.loadingText}
    <div>
      {@render loading()}
      <div>{props.loadingText}</div>
    </div>
  {:else}
    <div>
      {@render loading()}
    </div>
  {/if}
</LinkLocale>

<!-- snippets -->
{#snippet loading()}
  <Spinner />
{/snippet}
